<template>
	<div>
		<header class="mdc-top-app-bar darkModeHeader">
			<div class="d-flex align-items-center pdl-24 pdr-24 justify-conetent-between h-full">
				<div class="t-subtitle3 t-color-whiteHigh d-flex align-items-center pdr-24 font-r t-line-1 mgr-30">
					<!-- 차수이름이 노출됩니다. 세계적인 웹 캐스팅 소프트웨어 시장 통찰력 및 심층 분석 2021-2026 Digital Samba, Telestream, ON24, Facebook, Google, GoToWebinar, INXPO, 등 -->
					{{ lessonName }}
				</div>
				<div class="d-flex align-items-center justify-content-end flex-grow-1">
					<div class="position-relative w-80 mgr-24">
						<div class="percentage-wrapper">
							<div class="h-2 position-relative total-percentage bg-whiteBorder h-4">
								<div :style="{ width: rate + '%' }" class="real-percentage bg-saleLine b-radius0 h-4 mgt-2">
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex align-items-baseline mgr-24 t-nowrap">
						<div class="t-headline10 t-color-whiteHigh t-line-h-15 d-flex align-items-center font-b">
							{{ rate }}
						</div>
						<div class="t-body3 font-m mgl-4 t-color-whiteHigh">%</div>
					</div>
					<button
						class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4 pdl-12 pdr-12"
						tabindex="0" @click="moveLearnViewClose" @keypress="moveLearnViewClose">
						<span class="mdc-button__ripple"></span>
						<span class="mdc-button__label t-body2 font-r t-color-whiteHigh t-nowrap">{{ $t("3182") }}</span>
					</button>
				</div>
			</div>
			<div v-if="lightModeActive" class="divider"></div>
		</header>

		<div class="playerBG">
			<div id="pot" class="videoContiainer position-relative" style="height: 633px"
				@mouseleave="isControleOpen = false" @mouseover="isControleOpen = true">
				<video id="elementVideo" ref="videoPlayer" :poster="thumbnails" class="video-js" controlsList="nodownload"
					data-setup="{}" height="100%" preload="metadata" width="100%">
					<!-- <div class="progressbar">
							<progress max="100" value="80"></progress>
						</div> -->
					<track v-for="(subtitle, index) in subtitles" :key="index" :label="subtitle.language.text"
						:src="subtitle.file" :srclang="subtitle.language.value" kind="subtitles" />
					<!-- <source src="/img/movie.mp4" type="video/mp4" /> -->
					<p class="vjs-no-js">
						To view this video please enable JavaScript, and consider upgrading
						to a web browser that
						<a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
					</p>
				</video>
				<div
					class="waterMarkContainer position-absolute d-flex align-items-center justify-content-center flex-column">
					<div class="waterMarkInner">
						<div class="t-headline7 t-color-whiteSelected t-center mgb-16">
							{{ personalInfo ? personalInfo.userId : "" }}
						</div>
						<div class="t-headline7 t-color-blackHover t-center">
							{{ personalInfo ? personalInfo.userId : "" }}
						</div>
					</div>
				</div>
				<div :class="openScreen ? 'typography--resized' : ''"
					class="videoControls position-absolute w-full pdb-24 z-99">
					<div class="t-center">
						<div v-if="firstTrack &&
							firstTrack.cues[0] &&
							firstTrack.cues[0].startTime &&
							elementVideo.currentTime > firstTrack.cues[0].startTime - 1 &&
							elementVideo.currentTime <=
							firstTrack.cues[firstTrack.cues.length - 1].endTime &&
							setedFirstSubtitle
							" :class="lightModeActive
			? 'on t-color-whiteHighLight'
			: 'on t-color-whiteHigh'
		" class="typography--h7 firstSubtitle subtitle inline-flex bg-contentSubTextON pda-8 b-radius4 font-18">
						</div>
					</div>
					<div v-show="isControleOpen || !isPlaying" class="control-inner">
						<div v-if="endedLesson && nextLesson" class="d-flex justify-content-end w-full mgb-26 intro-button">
							<button id="hideButton" :class="lightModeActive
									? 'bg-whiteHighLight t-color-headlineBlack'
									: 'bg-secondaryBtn t-color-contentText'
								" class="mdc-button b-radius4" tabindex="0" @click="moveNextLesson(nextLesson)"
								@keypress="moveNextLesson(nextLesson)">
								<span class="mdc-button__ripple"></span>
								<i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
								<span class="mdc-button__label t-body2 font-r">{{ $t("959") }}{{ ": " + nextLesson.name
								}}</span>
								<span class="video-btn-overlay"></span>
							</button>
						</div>

						<div class="position-relative">
							<div v-show="isControlsVisible" class="range-slider">
								<input id="seekBar" v-model="setCurrentSlideValue"
									class="range-slider__range video-status w-full" data-orientation="vertical" max="100"
									min="0" type="range" @change="onChanged" @input="onSliding" :disabled="!learningPolicy.skipContents" :class="{'cursor-disabled': !learningPolicy.skipContents}" />
							</div>
						</div>

						<div class="controls d-flex justify-conetent-between align-items-center mgt-14">
							<div class="d-flex justify-conetent-between align-items-center flex-grow-1">
								<div class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
									:class="{'cursor-disabled': !learningPolicy.skipContents}"
									@click="moveBackward(learningPolicy.skipContents)"
									@keypress="moveBackward(learningPolicy.skipContents)">
									fast_rewind
								</div>
								<img v-show="!isPlaying" alt="play" class="mgr-28 w-24 h-24" src="/img/play.svg"
									tabindex="0" @click="onTogglePlayPause()" @keypress="onTogglePlayPause()" />
								<div v-show="isPlaying"
									class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
									@click="onTogglePlayPause()" @keypress="onTogglePlayPause()">
									pause
								</div>
								<div class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
									:class="{'cursor-disabled': !learningPolicy.skipContents}"
									@click="moveForward(learningPolicy.skipContents)"
									@keypress="moveForward(learningPolicy.skipContents)">
									fast_forward
								</div>
								<div class="timeControl desktop">
									<span :class="lightModeActive
											? 't-color-whiteMediumLight'
											: 't-color-whiteHigh'
										" class="currentTime t-body7 font-rn mgr-10" v-text="currentTimeParsed"></span>
									<span :class="lightModeActive
											? 't-color-whiteMediumLight'
											: 't-color-whiteHigh'
										" class="t-body7 font-rn">/</span>
									<span :class="lightModeActive
											? 't-color-whiteMediumLight'
											: 't-color-whiteHigh'
										" class="totalTime t-body7 font-rn mgl-10" v-text="fullLength"></span>
								</div>
							</div>

							<div class="d-flex justify-conetent-between align-items-center">
								<div class="position-relative">
									<img id="soundId" alt="sound" class="mgr-28 w-24 h-24" src="/img/sound.svg" tabindex="0"
										@click="setSoundHandler" @keypress="setSoundHandler" />
									<div v-if="isSound" :data-id="currentSound"
										class="range-slider volume-setting d-flex justify-conetent-center align-items-center pdl-16 pdr-16">
										<div class="volume-slider-wrapper">
											<input v-model="currentSound"
												:style="`background:linear-gradient(90deg, var(--Saleline) ${currentSound}%, var(--WhiteBorder) ${currentSound}%)`"
												class="custom-input range-slider__range" max="100" min="0" orient="vertical"
												type="range" @change="soundHandler" @input="soundHandler" />
										</div>
									</div>
								</div>
								<div id="playSpeed" class="position-relative">
									<img alt="play speed conrol" class="mgr-28 w-24 h-24" src="/img/play-speed.svg"
										tabindex="0" @click="setPlaybackHandler" @keypress="setPlaybackHandler" />
									<div class="position-absolute speed-control">
										<div v-if="isPlayback" class=" ">
											<ul aria-hidden="true" aria-orientation="vertical" class="mdc-list pdt-8 pdb-8"
												role="menu" tabindex="-1">
												<li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem"
													tabindex="0" @click="playBackItem" @keypress="playBackItem">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
														speed-data="0.5">
														<i :class="{
															'd-none':
																this.elementVideo &&
																this.elementVideo.playbackRate != '0.5',
														}" class="material-icons mgr-16">check</i>0.5</span>
												</li>
												<li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem"
													tabindex="0" @click="playBackItem" @keypress="playBackItem">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
														speed-data="0.7"><i :class="{
															'd-none':
																this.elementVideo &&
																this.elementVideo.playbackRate != '0.7',
														}" class="material-icons mgr-16">check</i>0.7</span>
												</li>
												<li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem"
													@click="playBackItem" @keypress="playBackItem">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
														speed-data="1">
														<i :class="{
															'd-none':
																this.elementVideo &&
																this.elementVideo.playbackRate != '1',
														}" class="material-icons mgr-16">check</i>
														1
														<!-- <span class="font-r t-color-whiteMedium pdl-8">(기본)</span> -->
													</span>
												</li>
												<li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem"
													@click="playBackItem" @keypress="playBackItem">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
														speed-data="1.25"><i :class="{
															'd-none':
																this.elementVideo &&
																this.elementVideo.playbackRate != '1.25',
														}" class="material-icons mgr-16">check</i>1.25</span>
												</li>
												<li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem"
													tabindex="0" @click="playBackItem" @keypress="playBackItem">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
														speed-data="1.5"><i :class="{
															'd-none':
																this.elementVideo &&
																this.elementVideo.playbackRate != '1.5',
														}" class="material-icons mgr-16">check</i>1.5</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="position-relative">
									<img id="subTitileIcon" alt="subtitle control" class="mgr-28 w-24 h-24"
										src="/img/subtitle.svg" tabindex="0" @click="setSubtitleHandler"
										@keypress="setSubtitleHandler" />

									<div class="position-absolute subtitle-setting">
										<div v-if="isSubtitlesVisible" class=" ">
											<ul aria-hidden="true" aria-orientation="vertical" class="mdc-list pdt-8 pdb-8"
												role="menu" tabindex="-1">
												<li class="mdc-list-item d-flex pdl-50 h-48" role="menuitem" tabindex="0"
													@click="setFirstSubtitle('')" @keypress="setFirstSubtitle('')">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh w-full d-flex align-items-center playBackItem pdl-12">
														<i v-show="setedFirstSubtitle === ''"
															class="material-icons mgr-16">check</i>
														{{ $t("1110") }}</span>
												</li>

												<li v-for="(subtitle, index) in subtitles" :key="index"
													class="mdc-list-item d-flex pdl-50 h-48" role="menuitem" tabindex="0"
													@click="setFirstSubtitle(subtitle.language.value)"
													@keypress="setFirstSubtitle(subtitle.language.value)">
													<span class="mdc-list-item__ripple"></span>
													<span
														class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex w-full align-items-center playBackItem pdl-12">
														<i v-show="setedFirstSubtitle === subtitle.language.value
															" class="material-icons mgr-16">check</i>
														{{ subtitle.language.text }}</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<!-- <img src="/img/subtitle.svg" alt="" class="mgr-28  w-24 h-24" @click="onToggleSubtitleSettings()"> -->
								<img id="hideShowFullScreen" alt="full screen" class="w-24 h-24" src="/img/arrow-extend.svg"
									tabindex="0" @click="openFullscreen(), toggleFullscreen()"
									@keypress="openFullscreen(), toggleFullscreen()" />
								<div id="hideShowPAndP"
									class="position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-none">
									<i :class="lightModeActive ? 't-color-white' : 't-color-whiteHigh'
										" class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
										@click.prevent="toggleAddedMenu" @keypress.prevent="toggleAddedMenu">more_vert</i>
									<div id="addedMenu" class="mdc-menu mdc-menu-surface toggle-menu">
										<ul aria-hidden="true" aria-orientation="vertical" class="mdc-list" role="menu"
											tabindex="-1">
											<li id="pictureInPicture" class="mdc-list-item" role="menuitem" tabindex="0"
												@click="pictureInPicture" @keypress="pictureInPicture">
												<i class="material-icons mdc-icon-button t-headline6">picture_in_picture</i>
												<!-- <i class="material-icons mdc-icon-button t-headline6">picture_in_picture_alt</i> -->
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r">{{
													$t("3330")
												}}</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 퀴즈 팝업 -->
				<timeline-quiz-pop v-if="isTimelineQuiz" :currentTimelineContents="currentTimelineContents"
					@closeQuizPop="closeQuizPop()" @openQuizDetail="openQuizDetail()" />

				<timeline-quiz-detail v-if="isQuizVisible" :currentTimelineContents="currentTimelineContents"
					:lightModeActive="lightModeActive" @closeQuizDetail="closeQuizDetail()" />

				<!-- 리소스 팝업 -->
				<timeline-resource-pop v-if="isTimelineResource" :currentTimelineContents="currentTimelineContents"
					@closeResource="closeResource()" @openResource="openResource()" />
			</div>
		</div>
		<div class="d-flex learning-content">
			<div class="d-flex flex-column w-full video-bottom">
				<main :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'"
					class="contentDarkModeContainer flex-grow-1">
					<div id="video-container" class="video-container">
						<div class="d-flex justify-content-between follow-wrapper">
							<div class="t-color-whiteHigh font-m t-headline13">
								{{ lessonName }}
							</div>
							<div class="d-flex align-items-center">
								<div class="d-flex align-items-center">
									<button :class="likes ? 't-color-red' : 't-color-whiteDisabled'"
										class="material-icons mdc-icon-button mgl--12 font-25" tabindex="0" @click="onLike"
										@keypress="onLike">
										favorite
									</button>
									<span class="t-body1 t-color-whiteHigh font-rn pdl-6">{{
										likesCount
									}}</span>
								</div>
								<div class="d-flex align-items-center mgl-26">
									<button :class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'
											" class="material-icons mdc-icon-button mgl--12 font-25" tabindex="0" @click="onBookmark"
										@keypress="onBookmark">
										bookmark
									</button>
									<span class="t-body1 t-color-whiteHigh font-rn pdl-6">{{
										clippingCount
									}}</span>
								</div>
								<button id="videoChatToggle" :class="lightModeActive
											? 'bg-contentPlayerBgLight'
											: 'bg-secondaryBtn'
										" class="mdc-button t-color-contentText min-w-210 mgl-50" tabindex="0" @click="setisQuestionAns"
									@keypress="setisQuestionAns">
									<div class="mdc-button__ripple"></div>
									<span class="mdc-button__label t-body2 font-r">{{
										$t("3184")
									}}</span>
								</button>
							</div>
						</div>

						<div class="mgt-4 t-body4 t-color-whiteHigh2 l-spacing42 font-r">
							{{ basicData ? basicData.category.text : null }} >
							{{ basicData ? basicData.category.child.text : null }}
						</div>
						<div v-if="basicData" class="mgt-4 t-body3 t-color-whiteHigh2 l-spacing42 font-r">
							<span v-for="(level, index) in basicData.levels" :key="index">
								{{ level.text }}
								{{ basicData.levels.length === index + 1 ? "" : "/" }}
							</span>
						</div>

						<div class="divider-white mgt-50"></div>
						<div class="subtabs mgb-32 darkMode">
							<div class="mdc-tab-bar main-tabs" role="tablist">
								<div class="mdc-tab-scroller pdl-12">
									<div class="mdc-tab-scroller__scroll-area">
										<div class="mdc-tab-scroller__scroll-content">
											<button class="mdc-tab min-w-auto mdc-tab--active" role="tab" tabindex="0"
												@click="tabChange('tab1')" @keypress="tabChange('tab1')">
												<span class="mdc-tab__content">
													<span class="mdc-tab__text-label font-m t-body7">{{ $t("1046") }}
													</span>
												</span>
												<span class="mdc-tab-indicator mdc-tab-indicator--active">
													<span
														class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
												</span>
												<span class="mdc-tab__ripple"></span>
											</button>
											<button class="mdc-tab min-w-auto" role="tab" tabindex="0"
												@click="tabChange('tab2')" @keypress="tabChange('tab2')">
												<span class="mdc-tab__content">
													<span class="mdc-tab__text-label font-m t-body7">{{
														$t("3185")
													}}</span>
												</span>
												<span class="mdc-tab-indicator">
													<span
														class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
												</span>
												<span class="mdc-tab__ripple"></span>
											</button>

											<button class="mdc-tab min-w-auto" role="tab" tabindex="0"
												@click="tabChange('tab4')" @keypress="tabChange('tab4')">
												<span class="mdc-tab__content">
													<span class="mdc-tab__text-label font-m t-body7">{{
														$t("1086")
													}}</span>
												</span>
												<span class="mdc-tab-indicator">
													<span
														class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
												</span>
												<span class="mdc-tab__ripple"></span>
											</button>
										</div>
									</div>
								</div>
							</div>

							<div class="divider-white divider-subtabs"></div>
						</div>

						<div v-if="currentTab === 'tab1'" class="t-body1 t-color-whiteHigh2">
							{{ learnPurposes }}
						</div>

						<div v-if="currentTab === 'tab2'" class="t-body2 t-color-whiteHigh2">
							<div class="mgt-32">
								<div id="selectDuty" class="mdc-select mdc-select--outlined mdc--select__custom--darkmode">
									<span class="mdc-select__dropdown-icon">
										<svg class="mdc-select__dropdown-icon-graphic" focusable="false"
											viewBox="7 10 10 5">
											<polygon class="mdc-select__dropdown-icon-inactive" fill-rule="evenodd"
												points="7 10 12 15 17 10" stroke="none"></polygon>
											<polygon class="mdc-select__dropdown-icon-active" fill-rule="evenodd"
												points="7 15 12 10 17 15" stroke="none"></polygon>
										</svg>
									</span>
									<select v-if="subtitles.length > 0" v-model="setedFirstSubtitle"
										:class="setedFirstSubtitle ? 'hasActiveVal' : ''"
										class="font-r mdc-select__native-control t-color-whiteHigh mdc-select__anchor h-48 mdc-select-control-custom t-body6 pdt-12 seleduty select-no-appearance"
										@change="onChangeLang($event)">
										<option :selected="setedFirstSubtitle === ''" value="">
											{{ $t("1110") }}
										</option>
										<option v-for="(subtitle, index) in subtitles" :key="index"
											:selected="setedFirstSubtitle === subtitle.language.value"
											:value="subtitle.language.value">
											{{ subtitle.language.text }}
										</option>
									</select>
									<select v-else
										class="font-r mdc-select__native-control t-color-whiteHigh mdc-select__anchor h-46 mdc-select-control-custom t-body6 pdt-12">
										<option value="None">
											{{ $t("1110") }}
										</option>
									</select>
									<div class="mdc-notched-outline">
										<div class="mdc-notched-outline__leading"></div>
										<div class="mdc-notched-outline__notch">
											<!-- <label class="mdc-floating-label">{{$t('759')}}</label> -->
										</div>
										<div class="mdc-notched-outline__trailing"></div>
									</div>
								</div>
							</div>

							<div v-if="subtitles.length > 0">
								<videotype-subtitle ref="videotypeSubtitles" :elementVideo="elementVideo"
									:firstTrack="firstTrack" :firstTrackStartTime="firstTrackStartTime"
									:lessonName="lessonName" :lightModeActive="lightModeActive"
									:secondTrack="secondTrackCues" :setedFirstSubtitle="setedFirstSubtitle" />
							</div>
							<div v-else class="t-body1 t-color-whiteHigh2 t-center mgt-28">
								<div class="subtitle-display">{{ $t("3321") }}</div>
							</div>
						</div>

						<div v-if="currentTab == 'tab4'" class="t-body2 t-color-whiteHigh2">
							<div class="video-lesson-slider">
								<lessons-list :currentProgressionId="currentProgressionId" :isQuestionAns="isQuestionAns"
									:lessonsList="lessonsList" :teacher="teacher" :teacherName="teacherName"
									:thumbnailVideo="thumbnailVideo"></lessons-list>
							</div>
						</div>
					</div>
				</main>
			</div>
			<question-ans v-if="isQuestionAns" :chatType="'learn'" :isQuestionAns="isQuestionAns"
				:learnId="this.$route.params.learnId" :lessonId="this.$route.params.lessonId"
				:lightModeActive="lightModeActive" :questionChat="questionChat"
				@setisQuestionAnsHandler="setisQuestionAns"></question-ans>

			<!-- Video start here -->
		</div>
		<div class="darkModeFixedButton" tabindex="0" @click="darkModeToLight()" @keypress="darkModeToLight()">
			<img :src="lightModeActive
					? '/img/dark-mode-button.png'
					: '/img/light-mode-button.svg'
				" alt="theme control" class="cursor-pointer" />
		</div>
	</div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 비디오 컨텐츠 컴포넌트(my learning lesson study - video content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
import { videoTypeMixins } from "../../mixins/videoType.js";

import VideoTypeSubtitle from "./VideoTypeSubtitle.vue";
import VideoTypeSettingSubtitles from "./VideoTypeSettingSubtitles.vue";
import LessonsList from "./LessonsListVideo.vue";
import questionAns from "../question/List.vue";

import TimelineQuizPop from "./TimelineQuizPop.vue";
import TimelineQuizDetail from "./TimelineQuizDetail.vue";
import TimelineResourcePop from "./TimelineResourcePop.vue";
import LikeAndBookmark from "./LikeAndBookmark.vue";
import PopNextLesson from "./PopNextLesson.vue";
import { MDCRipple } from "@material/ripple";
import localStorageUtil from "@/utils/localStorageUtil";
export default {
	data() {
		return {
			lessonData: null,
			lessonName: "",
			video: null,
			lessonsList: [],
			nextLessonName: "",
			currentProgressionId: "",
			rate: 0,
			last: 0,
			recent: 0,
			showLectureList: false,

			//타임라인 관련 데이터(timeline data)
			isTimelineQuiz: false,
			isTimelineResource: false,
			timelineContents: [],
			currentTimelineContents: null,

			// 북마크 좋아요 관려 데이터(like & bookmark data)
			isLiked: false,
			isBookmarked: false,
			likes: false,
			likesCount: 0,
			clipping: false,
			clippingCount: 0,

			// 자막 관련 데이터(subtitles data)
			subtitles: [],
			setedFirstSubtitle: "",
			setedSecondSubtitle: null,
			firstTrack: null,
			secondTrack: null,
			firstTrackStartTime: 0,
			secondTrackStartTime: 0,
			firstTrackCues: null,
			secondTrackCues: null,

			endedLesson: false,
			nextLesson: null,

			personalInfo: null,

			type: "video",
			thumbnailVideo: "",
			//isLandscapOverlay:false,

			// nextLessonDialog: null
			currentTab: "tab1",
			name: "",
			teacher: "",
			teacherName: "",
			learnPurposes: "",
			basicData: null,
			thumbnails: null,
			questionChat: null,
			togglePipButton: null,
			addedMenu: null,
			hideVideoTiSub: false,
			slidingVideoArr: [],
			lightModeActive: false,
			tab2Val: false,
			timerId: null,
			openScreen: false,
			learningPolicy: false,
			isConsistExam: true,
		};
	},
	mixins: [videoTypeMixins],
	components: {
		"videotype-subtitle": VideoTypeSubtitle,
		"videoType-setting-subtitles": VideoTypeSettingSubtitles,
		"lessons-list": LessonsList,
		"timeline-quiz-detail": TimelineQuizDetail,
		"timeline-quiz-pop": TimelineQuizPop,
		"timeline-resource-pop": TimelineResourcePop,
		"pop-next-lesson": PopNextLesson,
		"like-and-bookmark": LikeAndBookmark,
		"question-ans": questionAns,
	},

	computed: {
		setCurrentSlideValue() {
			this.setMaterialUi();
			this.setSubtitles(this.$data);
			return this.currentSlideValue;
		},
	},

	mounted() {
		const article = document.querySelector("html");
		const modeContent = article.getAttribute("data-theme");
		if (localStorage.getItem("themeMode")) {
			article.setAttribute("data-theme", localStorage.getItem("themeMode"));
			this.lightModeActive = localStorage.getItem("themeMode") !== "dark";
		} else {
			if (modeContent === "dark") {
				this.lightModeActive = false;
			} else {
				this.lightModeActive = true;
			}
		}

		// video full scree
		$(document).bind(
			"webkitfullscreenchange mozfullscreenchange fullscreenchange",
			() => {
				var state =
					document.fullScreen ||
					document.mozFullScreen ||
					document.webkitIsFullScreen;
				var event = state ? "FullscreenOn" : "FullscreenOff";

				// full screen on and off
				if (event === "FullscreenOff") {
					this.openScreen = false;
					document.getElementById("hideShowPAndP").classList.add("d-none");
					document
						.getElementById("hideShowFullScreen")
						.classList.remove("d-none");
					document.getElementById("subTitileIcon").classList.add("mgr-28");
					document.getElementById("subTitileIcon").classList.remove("d-none");
					document.getElementById("playSpeed").classList.remove("d-none");
					document.getElementById("soundId").classList.add("mgr-28");
				} else {
					this.openScreen = true;
					document.getElementById("hideShowPAndP").classList.remove("d-none");
					document.getElementById("hideShowFullScreen").classList.add("d-none");
					document.getElementById("subTitileIcon").classList.remove("mgr-28");
					document.getElementById("subTitileIcon").classList.add("d-none");
					document.getElementById("playSpeed").classList.add("d-none");
					document.getElementById("soundId").classList.remove("mgr-28");
				}
			}
		);

		if (document.querySelectorAll(".toggle-menu")) {
			const menuEls = Array.from(document.querySelectorAll(".toggle-menu"));
			menuEls.forEach((menuEl) => {
				// Initialize MDCSimpleMenu on each ".mdc-simple-menu"
				const menu = new mdc.menu.MDCMenu(menuEl);
				// We wrapped menu and toggle into containers for easier selecting the toggles
				const dropdownToggle = menuEl.parentElement.querySelector(
					".js--dropdown-toggle"
				);
				dropdownToggle.addEventListener("click", () => {
					menu.open = !menu.open;
				});
			});
		}
		
		learnApi.openNextLearning(this.$route.params.learnId)
        	.then(() => {
				learnApi
					.learnLessonObjective({
						learnId: this.$route.params.learnId,
						progressionId: this.$route.params.progressionId,
					})
					.then((response) => {
						let responseData = response.data.data;
						this.name = responseData.name;
						this.teacher = responseData.teacher ? responseData.teacher : "";
						this.teacherName = responseData.teacher
							? responseData.teacher.fullName
							: "";
						this.learnPurposes = this.getLearnPurposes(responseData.learnInfo);
					});
			})
			.catch((err) => {
				console.log("ERROR OPEN NEXT LEARNING API : ", err);
			})

		if (typeof this.$route.query.questionChatType != "undefined") {
			this.questionChat = this.$route.query.questionChatType;
			document.getElementById("videoChatToggle").click();
		}

		let params = this.setParams();
		let responseData = null;
		this.setMaterialUi();

		//차시 컨텐츠 정보 API 호출(get lesson contents data)
		learnApi
			.learnLessonContents(params)
			.then((response) => {
				responseData = response.data.data;

				this.lessonData = responseData;
				this.lessonName = this.lessonData.lessonName;
				this.rate = this.lessonData.rate;
				this.video = this.lessonData.video;
				this.last = this.lessonData.last;
				this.recent = this.lessonData.recent;
				this.totalTime = this.lessonData.video.duration;
				this.subtitles = this.lessonData.video.subtitles;
				this.thumbnails = this.lessonData.video.thumbnails[0];
				this.currentProgressionId = this.lessonData.progressionId;

				this.elementVideo.src = this.video.file;
				this.likes = this.lessonData.likes;
				this.likesCount = this.lessonData.likesCount;
				this.clipping = this.lessonData.clipping;
				this.clippingCount = this.lessonData.clippingCount;

				// 학습중일 경우 처음부터 보기 이어보기 팝업(If you are learning, pop-up view from the beginning)
				if (this.rate > 0 && this.rate < 100) {
					this.$confirm({
						title: this.$t("173"), // '학습 중인 강의입니다.',
						content: this.$t("174") + "<br>" + this.$t("175"), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
						accept: this.$t("177"), //'이어서 보기',
						cancel: this.$t("176"), //'처음부터 보기',
					})
						.then(() => {
							this.elementVideo.currentTime = this.recent;
							this.elementVideo.play();
						})
						.catch(() => {
							this.elementVideo.currentTime = 0;
							this.elementVideo.play();
						});
				} else {
					this.elementVideo.play();
				}

				this.fetchLectureList();
			})
			.catch((err) => { });

		learnApi
			.learnViewBasic(params)
			.then((response) => {
				this.learningPolicy = response.data.data.learningPolicy;
				let getThumbnail = response.data.data;
				this.thumbnailVideo = getThumbnail.thumbnail;
				this.basicData = getThumbnail;
			})
			.catch((err) => { });

		// 동영상 재생시 자막 설정(Subtitle settings during video playback)
		this.elementVideo.onplay = () => {
			this.setSubtitles();
		};

		// 동영상 끝났을 경우 진도 저장(Save progress when video is over)
		this.elementVideo.onended = async () => {
			let myLession = this.nextLesson;
			let myRoute = this.$route;
			let myRouter = this.$router;
			this.endedLesson = true;
			this.updateProgress();
			await this.openNextLearning();
			this.fetchLectureList();

			var self = this;
			this.timerId = setTimeout(function () {
				let learnId = myRoute.params.learnId;
				let status = myRoute.query.status;
				if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "VIDEO"
				) {
					myRouter.push(
						`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "EXAM_PAPER"
				) {
					myRouter.push(
						`/learn/${learnId}/lessonExam/${myLession.examineeId}/intro?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "PDF"
				) {
					myRouter.push(
						`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "SLIDE"
				) {
					myRouter.push(
						`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "HTML"
				) {
					myRouter.push(
						`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "INTERACTIVE_HTML"
				) {
					myRouter.push(
						`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
						status
					);
				} else if (
					myLession &&
					myLession.contentsType &&
					myLession.contentsType.value === "LIVE_SESSION"
				) {
					self.liveLessonPopup(myLession, myRoute, myRouter);
				} else {
					myRouter.push(`/learn/${learnId}?status=` + status);
				}
			}, 5000);

			document.addEventListener("mousemove", this.eventHandler);
			document.addEventListener("keydown", this.eventHandler);
		};

		// 동영상 재생 준비 완료되었을 경우 재생(Play when video is ready to play)
		this.elementVideo.onloadeddata = () => {
			if (this.elementVideo.readyState >= 2) {
				this.elementVideo.play();
			}
		};

		// 타임라인 컨텐츠 정보 API 호출(get timeline data)
		learnApi
			.learnLessonTimelinecontents(params)
			.then((response) => {
				responseData = response.data.data;
				this.timelineContents = responseData;
			})
			.catch((err) => { });

		learnApi.getMemberInfo().then((response) => {
			this.personalInfo = response.data.data;
		});

		this.getExamInfo();
	},

	beforeDestroy() {
		document.removeEventListener("mousemove", this.eventHandler);
		document.removeEventListener("keydown", this.eventHandler);
		this.exitPiPMode();
	},

	methods: {
		eventHandler() {
			const hideButton = document.querySelector("#hideButton");
			if (hideButton) {
				hideButton.style.display = "none";
			}
			clearTimeout(this.timerId);
		},
		// Live lesson alert
		liveLessonPopup(myLession, myRoute, myRouter) {
			let params = {
				learnId: myRoute.params.learnId,
				progressionId: myLession.progressionId,
			};
			learnApi
				.learnLessonContents(params)
				.then((response) => {
					let liveSessionTrueFalse =
						response.data.data.liveSession.canParticipate;
					if (liveSessionTrueFalse == false) {
						this.$alert({
							title: this.$t("3434"), // 학습을 중단한 강의입니다.
							content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
							accept: this.$t("3436"), // 확인
						})
							.then(() => {
								document.getElementById("hideButton").style.display = "none";
							})
							.catch(() => { });
					} else {
						this.$router.push({
							name: "LessonView",
							params: {
								learnId: myRoute.params.learnId,
								lessonId: myLession.id,
								progressionId: myLession.progressionId,
							},
							query: this.$route.query,
						});
					}
				})
				.catch((err) => { });
		},
		// change the mode from dark to light and light to dark
		darkModeToLight() {
			const article = document.querySelector("html");
			const modeContent = article.getAttribute("data-theme");
			localStorage.setItem(
				"themeMode",
				modeContent == "dark" ? "light" : "dark"
			);
			article.setAttribute(
				"data-theme",
				modeContent == "dark" ? "light" : "dark"
			);
			this.lightModeActive = !this.lightModeActive;
		},
		// Move to next leasson
		moveNextLesson(lesson) {
			let learnId = this.$route.params.learnId;
			let status = this.$route.query.status;
			if (
				lesson &&
				lesson.contentsType &&
				lesson.contentsType.value === "VIDEO"
			) {
				this.$router.push(
					`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contentsType &&
				lesson.contentsType.value === "EXAM_PAPER"
			) {
				this.$router.push(
					`/learn/${learnId}/lessonExam/${lesson.examineeId}/intro?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contentsType &&
				lesson.contentsType.value === "PDF"
			) {
				this.$router.push(
					`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contentsType &&
				lesson.contentsType.value === "SLIDE"
			) {
				this.$router.push(
					`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contents &&
				lesson.contents.lcms &&
				lesson.contents.lcms.type &&
				lesson.contents.lcms.type.value === "HTML"
			) {
				this.$router.push(
					`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contents &&
				lesson.contents.lcms &&
				lesson.contents.lcms.type &&
				lesson.contents.lcms.type.value === "INTERACTIVE_HTML"
			) {
				this.$router.push(
					`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
					status
				);
			} else if (
				lesson &&
				lesson.contentsType &&
				lesson.contentsType.value === "LIVE_SESSION"
			) {
				let params = {
					learnId: this.$route.params.learnId,
					progressionId: lesson.progressionId,
				};
				learnApi
					.learnLessonContents(params)
					.then((response) => {
						let liveSessionTrueFalse =
							response.data.data.liveSession.canParticipate;
						if (liveSessionTrueFalse === false) {
							this.$alert({
								title: this.$t("3434"), // 학습을 중단한 강의입니다.
								content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
								accept: this.$t("3436"), // 확인
							})
								.then(() => { })
								.catch(() => { });
						} else {
							this.$router.push({
								name: "LessonView",
								params: {
									learnId: this.$route.params.learnId,
									lessonId: lesson.id,
									progressionId: lesson.progressionId,
								},
								query: this.$route.query,
							});
						}
					})
					.catch((err) => { });
			} else {
				this.$router.push(`/learn/${learnId}?status=` + status);
			}
		},
		// change sub titie based languge
		onChangeLang(event) {
			this.setFirstSubtitle(event.target.value);
		},
		// set sub titile
		setFirstSubtitle(language) {
			if (this.firstSubtitle === language) {
				// this.firstSubtitle = ''
			} else {
				this.firstSubtitle = language;
			}
			this.setSubtitles(this.$data);
		},

		toggleAddedMenu() {
			this.addedMenu.open = !this.addedMenu.open;
		},

		// set picture in picture
		pictureInPicture() {
			this.video = document.getElementById("elementVideo");
			this.togglePipButton = document.getElementById("pictureInPicture");
			this.togglePipButton.hidden =
				!document.pictureInPictureEnabled || this.video.disablePictureInPicture;
			this.video.requestPictureInPicture();
			this.togglePipButton.addEventListener("click", async () => {
				await this.video.requestPictureInPicture();
			});
		},
		// like and book mark video
		setLikeAndBookParams() {
			let params = {
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};
			return params;
		},

		onLike() {
			let params = this.setLikeAndBookParams();
			let responseData = null;
			if (this.likes) {
				learnApi
					.learnLessonLikesDelete(params)
					.then((response) => {
						responseData = response.data.data;
						//this.heartcolor={'color':'#758191 !important'}
						this.likes = response.data.data;
						this.likesCount = this.likesCount - 1;
					})
					.catch((err) => { });
			} else {
				learnApi
					.learnLessonLikesPost(params)
					.then((response) => {
						//this.heartcolor={'color':'var(--secondaryBtnText) !important'}
						responseData = response.data.data;
						this.likes = response.data.data;
						this.likesCount = this.likesCount + 1;
					})
					.catch((err) => { });
			}
		},

		// 북마크 API 호출(set/cancel bookmark)
		onBookmark() {
			let params = this.setParams();
			let responseData = null;
			if (this.clipping) {
				learnApi
					.learnLessonClippingDelete(params)
					.then((response) => {
						responseData = response.data.data;
						this.clipping = responseData;
						this.clippingCount = this.clippingCount - 1;
						this.toggleBookmarkIcon();
					})
					.catch((err) => { });
			} else {
				learnApi
					.learnLessonClippingPost(params)
					.then((response) => {
						responseData = response.data.data;
						this.clipping = responseData;
						this.clippingCount = this.clippingCount + 1;
					})
					.catch((err) => { });
			}
		},

		// 진도저장 API 호출(update progress)
		updateProgress() {
			let params = this.setParams();
			let responseData = null;
			learnApi
				.learnLessonProgression(params)
				.then((response) => {
					responseData = response.data.data;
					this.rate = responseData.rate;
					this.last = responseData.last;
				})
				.catch((err) => { });
		},

		async openNextLearning() {
			try {
				await learnApi.openNextLearning(this.$route.params.learnId)
			} catch (error) {
				console.log("Open Next Learning Error : ", error);
			}
		},

		// API 파라미터 설정(set parameter)
		setParams() {
			let params = {
				total: this.elementVideo.duration,
				current: this.elementVideo.currentTime,
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};
			return params;
		},

		// 자막 설정(set subtitles)
		setSubtitles(data) {
			let firstSubtitle = document.getElementsByClassName("firstSubtitle");
			let secondSubtitle = document.getElementsByClassName("secondSubtitle");

			// 기본자막 설정(Default subtitle setting)
			if (!data && this.lessonData.video.subtitles.length) {
				data = {
					firstSubtitle: this.lessonData.video.subtitles[0].language.value,
					secondSubtitle: "",
				};
			}

			if (data) {
				// set first subtitles
				if (data.firstSubtitle) {
					this.setedFirstSubtitle = data.firstSubtitle;
					this.firstTrack =
						this.elementVideo.textTracks[
						_.findIndex(this.elementVideo.textTracks, (track) => {
							return track.language === data.firstSubtitle;
						})
						];

					this.firstTrack.mode = "hidden";
					this.firstTrackCues = this.firstTrack.cues;

					// 비디오 진도 바뀔때(When the video progress changes)
					this.firstTrack.oncuechange = (e) => {
						let cue = this.firstTrack.activeCues[0];
						if (cue) {
							this.firstTrackStartTime = cue.startTime;

							for (let i = 0; i < firstSubtitle.length; i++) {
								firstSubtitle[i].classList.remove("on");
								firstSubtitle[i].innerHTML = "";
								firstSubtitle[i].classList.add("on");
								firstSubtitle[i].appendChild(cue.getCueAsHTML());
							}
						}
					};
				} else {
					if (this.firstTrack) {
						this.setedFirstSubtitle = "";
						this.firstTrack.oncuechange = () => { };
						this.firstTrack = null;
						this.firstTrackCues = null;
					}

					for (let i = 0; i < firstSubtitle.length; i++) {
						firstSubtitle[i].innerHTML = "";
					}
				}

				// set second subtitles
				if (data.secondSubtitle) {
					this.setedSecondSubtitle = data.secondSubtitle;
					this.secondTrack =
						this.elementVideo.textTracks[
						_.findIndex(this.elementVideo.textTracks, (track) => {
							return track.language === data.secondSubtitle;
						})
						];

					this.secondTrack.mode = "hidden";
					this.secondTrackCues = this.secondTrack.cues;
					// 비디오 진도 바뀔때(When the video progress changes)
					this.secondTrack.oncuechange = (e) => {
						let cue = this.secondTrack.activeCues[0];
						this.secondTrackStartTime = cue.startTime;
						if (cue) {
							for (let i = 0; i < secondSubtitle.length; i++) {
								secondSubtitle[i].classList.remove("on");
								secondSubtitle[i].innerHTML = "";
								secondSubtitle[i].classList.add("on");
								secondSubtitle[i].appendChild(cue.getCueAsHTML());
							}
						}
					};
				} else {
					if (this.secondTrack) {
						this.setedSecondSubtitle = "";
						this.secondTrack.oncuechange = () => { };
						this.secondTrack = null;
						this.secondTrackCues = null;
					}
					for (let i = 0; i < secondSubtitle.length; i++) {
						secondSubtitle[i].innerHTML = "";
					}
				}
			}
		},

		//나의 학습 상세로 이동(Go to my learning details)
		moveLearnView() {
			let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
			let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
			if (goBackBookMarkLessson == "setVideoBookMarkLesson") {
				localStorage.removeItem("videoBookMarkLesson");
				this.$router.push({
					name: "BookMarkedLesson",
				});
			} else if (goBackLikeLessson == "setVideoLikeLesson") {
				localStorage.removeItem("videoLikeLesson");
				this.$router.push({
					name: "LikedLesson",
				});
			} else {
				this.$router.push({
					name: "LearnView",
					params: { learnId: this.$route.params.learnId },
					query: this.$route.query,
				});
			}
		},

		moveLearnViewClose() {
			let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
			let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
			if (goBackBookMarkLessson == "setVideoBookMarkLesson") {
				localStorage.removeItem("videoBookMarkLesson");
				this.$router.push({
					name: "BookMarkedLesson",
				});
			} else if (goBackLikeLessson == "setVideoLikeLesson") {
				localStorage.removeItem("videoLikeLesson");
				this.$router.push({
					name: "LikedLesson",
				});
			} else if (typeof this.$route.query.questionChatType != "undefined") {
				this.$router.push({
					name: "LearnView",
					params: { learnId: this.$route.params.learnId },
					query: { status: this.$route.query.status, tab: "ViewQuestion" },
				});
			} else {
				this.$router.push({
					name: "LearnView",
					params: { learnId: this.$route.params.learnId },
					query: this.$route.query,
				});
			}
		},
		// Move to independent survey
		takeSurvey(id, respondentId, surveyDistributionType) {
			let params = {
				distId: id,
				respondentId: respondentId,
			};

			this.$router.push({
				name: "IndependentSurveyIntro",
				params: params,
				query: {
					status: this.$route.query.status,
					learnId: this.$router.currentRoute.params.learnId,
					distributionType: surveyDistributionType,
				},
			});
		},

		// update likes count
		updateLikesCount(data) {
			this.likes = data.likes;
			this.likesCount = data.likesCount;
		},

		// update bookmark count
		updateBookmarkCount(data) {
			this.clipping = data.clipping;
			this.clippingCount = data.clippingCount;
		},

		// 학습 목록 API 호출(get lesson list)
		fetchLectureList() {
			let responseData = null;
			let params = this.setParams();

			let lessonsListArr = [];

			learnApi
				.learnViewCourses(params)
				.then((response) => {
					// Merging only lesson data from the course
					_.each(response.data.data, (course) => {
						lessonsListArr = [...lessonsListArr, ...course.lessons];
					});
					this.lessonsList = lessonsListArr;

					// 다음 차시명 설정(set next lesson)
					let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
						return lesson.progressionId === this.currentProgressionId;
					});
					let nextLessonIndex =
						this.lessonsList.length > 1 &&
							this.lessonsList.length > currentLessonIndex
							? (currentLessonIndex += 1)
							: -1;

					if (nextLessonIndex) {
						this.nextLesson = this.lessonsList[nextLessonIndex];

						if (nextLessonIndex === -1) {
							this.nextLessonName = this.$t("1999");
						} else {
							if (typeof this.lessonsList[nextLessonIndex] != "undefined") {
								this.nextLessonName = this.lessonsList[nextLessonIndex].name;
							} else {
								this.nextLessonName = this.$t("1999");
							}
						}
					}
				})
				.catch((err) => { });
		},

		// 타임라인 퀴즈 팝업 닫기(Close the timeline quiz popup)
		closeQuizPop() {
			this.isTimelineQuiz = false;
		},

		// 질문하기로 이동(Go to Ask a Question)
		moveQuestion() {
			this.$router.push({
				name: "LessonViewQuestion",
				query: this.$route.query,
			});
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(
				document.querySelectorAll(
					".mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set"
				),
				function (el) {
					let button = new MDCRipple.attachTo(el);
					return button;
				}
			);

			if (document.querySelector(".mdc-tab-bar")) {
				var tabBar = new mdc.tabBar.MDCTabBar(
					document.querySelector(".mdc-tab-bar")
				);
			}

			// First let's set the colors of our sliders
			const settings = {
				fill: `var(--Saleline)`,
				background: "rgba(255, 255, 255, 0.38)",
			};

			// First find all our sliders
			const sliders = document.querySelectorAll(".range-slider");

			// Iterate through that list of sliders
			// ... this call goes through our array of sliders [slider1,slider2,slider3] and inserts them one-by-one into the code block below with the variable name (slider). We can then access each of wthem by calling slider
			Array.prototype.forEach.call(sliders, (slider) => {
				slider.querySelector("input").addEventListener("input", (event) => {
					// 1. apply our value to the span
					applyFill(event.target);
				});
				// Don't wait for the listener, apply it now!
				applyFill(slider.querySelector("input"));
			});

			// This function applies the fill to our sliders by using a linear gradient background
			function applyFill(slider) {
				// Let's turn our value into a percentage to figure out how far it is in between the min and max of our input
				const percentage =
					(100 * (slider.value - slider.min)) / (slider.max - slider.min);
				const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background
					} ${percentage + 0.1}%)`;
				slider.style.background = bg;
			}
		},

		getLearnPurposes(obj) {
			const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
			const learnInfo = obj.find(
				(info) => info.lang.value === languageInfo.code
			);
			return learnInfo ? learnInfo.summary : "";
		},

		tabChange(currentTab) {
			this.currentTab = currentTab;
			if (this.currentTab === "tab2") {
				this.tab2Val = true;
			} else {
				this.tab2Val = false;
			}
		},

		toggleFullscreen() {
			if (!document.fullscreenElement) {
				document.getElementById("hideShowPAndP").classList.remove("d-none");
			} else if (document.exitFullscreen) {
				document.getElementById("hideShowPAndP").classList.add("d-none");
			}
		},

		async getExamInfo() {
			const params = this.setParams();
			try {
				const result = await learnApi.learnViewExams(params);
				if (result && result.data.data && result.data.data.length === 0) {
					this.isConsistExam = false;
				}
			} catch (error) {
				console.log("GET EXAM ERROR : ", error);
			}
		},
	},
};
</script>
<style scoped>
.header-toggle .toggle-menu {
	top: -68px !important;
}

.video-chat-wrapper {
	box-sizing: border-box;
	width: 0;
	margin-top: 50px;
	border-radius: 4px;
	max-height: 600px;
	border: 1px solid var(--WhiteBorder);
	border-width: 0;
	margin-right: 0;
}

html[dir="rtl"] .video-chat-wrapper {
	margin-left: 0;
}

.border-box {
	box-sizing: border-box;
}

.video-chat-wrapper #autoheighttext::-webkit-scrollbar {
	display: none;
}

.b-radius24 {
	border-radius: 24px;
}

.video-chat-wrapper .chatDate::after {
	display: none;
}

.video-chat-wrapper .chatMessageBox:not(:first-child) {
	margin-top: 8px !important;
}

.video-chat-wrapper .chatMessageBox:last-child {
	margin-top: 0px;
}

.chatReplyMessageBox:first-child {
	margin-top: 34px !important;
}

.hide-scrollbar::-webkit-scrollbar {
	display: none;
}

.without-image {
	padding-left: 52px;
}

.chatReplyMessageBox:last-child {
	margin-bottom: 34px;
}

.video-chat-wrapper .video-chat-header>div {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.video-chat-wrapper .square-image.attached-image-preview {
	max-width: 62px;
	margin-right: 8px;
	margin-bottom: 16px;
	position: relative;
}

html[dir="rtl"] .video-chat-wrapper .square-image.attached-image-preview {
	margin-left: 8px;
}

.video-chat-wrapper .comment-section .quoteTo {
	left: 24px;
	top: 12px;
}

html[dir="rtl"] .video-chat-wrapper .comment-section .quoteTo {
	right: 24px;
}

.video-chat-wrapper .comment-section #autoheighttext.teacher {
	text-indent: 80px;
}

.video-chat-wrapper .comment-section #autoheighttext.colleague {
	text-indent: 90px;
}

.video-chat-wrapper .comment-section #autoheighttext.everyone {
	text-indent: 115px;
}

.video-chat-wrapper .comment-section #autoheighttext.teacher.colleague {
	text-indent: 170px;
}

.video-chat-wrapper .comment-section #autoheighttext.teacher.everyone {
	text-indent: 185px;
}

.video-chat-wrapper .comment-section #autoheighttext.colleague.everyone {
	text-indent: 195px;
}

.video-chat-wrapper .comment-section #autoheighttext.teacher.colleague.everyone {
	text-indent: 260px;
}

.video-chat-wrapper #autoheighttext {
	color: var(--WhiteHigh) !important;
}

.video-chat-wrapper #autoheighttext:focus {
	color: var(--WhiteHigh) !important;
}

.video-container.chat-active {
	padding-right: 50px;
}

html[dir="rtl"] .video-container.chat-active {
	padding-left: 50px;
}

/* .video-container.chat-active .video-chat-wrapper {} */

.video-container.chat-active .min-w-210 {
	display: none;
}

.video-container:not(.chat-active) .video-lesson-slider .container {
	margin-left: 0 !important;
	max-width: 100%;
}

html[dir="rtl"] .video-container:not(.chat-active) .video-lesson-slider .container {
	margin-right: 0 !important;
}

.video-bottom.video-chat-active {
	max-width: calc(100% - 577px);
}

#addedMenu {
	top: -64px !important;
	min-width: 220px;
}

.mdc-select-control-custom {
	border-radius: 4px;
	padding-top: 9px;
}

.bg-contentSubTextON.on {
	background: var(--ContentSubtext) !important;
}

.mdc-select-control-custom option {
	color: var(--ContentsDarkmodeAppbar) !important;
}

.mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__native-control,
.mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__selected-text {
	color: var(--HeadlineBlack) !important;
}

.mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__native-control,
.mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__selected-text {
	color: var(--HeadlineBlack) !important;
}

/* .mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__native-control, .mdc-select.hasActiveVal:not(.mdc-select--disabled) .mdc-select__selected-text{
	color: var(--HeadlineBlack) !important;
} */
.hasActiveVal select {
	color: var(--HeadlineBlack) !important;
}

.mdc-select--outlined.hasActiveVal select {
	color: var(--HeadlineBlack) !important;
}

/* .mdc-select--outlined.seleduty select option {
	color: var(--BodygrayA) !important;
} */
select.mdc-select__native-control.mdc-select__anchor.h-48.mdc-select-control-custom {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	color: var(--headlineHigh) !important;
}

#elementVideo {
	object-fit: contain !important;
	width: 100% !important;
	height: 100% !important;
}

.playerBG {
	background: var(--ContentsPlayerBG) !important;
	padding: 64px 0px 0px 0px !important;
}

.contentDarkModeContainer .video-container .subtabs.darkMode .mdc-tab {
	height: 64px;
	min-width: 94px !important;
	padding-left: 14px;
	padding-right: 14px;
}

.cursor-disabled {
  cursor: not-allowed !important; 
  color: var(--WhiteDisabled) !important;
}
</style>
